import { render, staticRenderFns } from "./WizardStepIndicator_refactor.vue?vue&type=template&id=2298471b&scoped=true&"
import script from "./WizardStepIndicator_refactor.vue?vue&type=script&lang=js&"
export * from "./WizardStepIndicator_refactor.vue?vue&type=script&lang=js&"
import style0 from "./WizardStepIndicator_refactor.vue?vue&type=style&index=0&id=2298471b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2298471b",
  null
  
)

export default component.exports